/**
 * NOTIFICATION-PANEL
 * Information panel on the left of the screen
 */

import SidePanel from "../../../components/SidePanel"
import { Notification } from "../model/notification.types"
import NotificationCard from "./NotificationCard"

interface Props {
  notifications: Notification[]
}

export default function NotificationsPanel(props: Props) {
  return (
    <SidePanel width={320} defaultOpen={props.notifications.length > 0} side="left">
      <div className="mt-[30px] mb-[30px] text-lg text-center">Mes tâches</div>

      {props.notifications.length === 0 && (
        <div className="grey-t px-20 text-center text-sm">Aucune tâche à faire pour le moment.</div>
      )}

      {props.notifications.map((notification, i) => (
        <NotificationCard key={notification.id ?? i} notification={notification} isPrimary={i === 0} />
      ))}
    </SidePanel>
  )
}
